// removed by extract-text-webpack-plugin
module.exports = {"ForgotPassword":"wouu7tj9uT1ntFZWpLdGR","ForgotPasswordPanel":"krtFm-JxFozK-vHcqH25e","Title":"_3F7skapgpjAHlFo1qOJt-x","Input":"_23LUqT9kaUJWGt-gEIeL0K","ButtonContainer":"_2BhEBXJVQSCF5tsa_Qrshr","ResetPasswordButton":"_3ILcJZ_8vXAcwejPx8gHxt","Error":"_235oVmv3-D9IDrKYpHAEEk","BackLink":"ulbxpwk1SWMgzo0AoZO9h","Text":"_12s_UEl-B8HUR0HtCR8roE"};


//////////////////
// WEBPACK FOOTER
// ./src/ConnectedComponents/ForgotPassword/index.css
// module id = 1424
// module chunks = 1